import React from 'react';
import DashboardHeader from '../components/Header/HeaderMetrics';
import CasesList from '../components/CaseList/CaseList';

const DashboardSummary = () => {
  return (
    <div className="flex flex-col gap-4 h-screen">
        <div><CasesList /></div>
    </div>
  );
};

export default DashboardSummary;
